export default "__VITE_ASSET__qxd_Rv4b__"